import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Store";
import {
  error,
  noPermissionAlert,
  success,
  waringMessage,
} from "../../Services/CommonService";
import {
  useAddBookmarkMutation,
  useApplyJobMutation,
} from "../../Store/api/DataApi";
import { actionLogout } from "../../Store/slices/AuthSlice";

export default function JobPostComponent(props) {
  const {
    id,
    company_name,
    job_title,
    //job_details,
    profile_image,
    //job_ctc,
    locations,
    //  full_time,
    //  part_time,
    //  wfh,
    //  intership,
  } = props?.item;
  const { path = "" } = props;
  const { isAuth, profile } = useSelector((state: RootState) => state.auth);
  const [applyJob] = useApplyJobMutation();
  const [addBookmark] = useAddBookmarkMutation();

  const [jobNature, setJobNature] = useState([]);

  const dispatch = useDispatch();

  //const jobNature = [];

  const handleBookmark = useCallback(
    (id) => {
      if (isAuth && profile?.lgbt_status === 1) {
        addBookmark(id)
          .then((res) => {
            //console.log(res.error.data.error);
            if (res?.error?.data?.error !== undefined) {
              error(res?.error?.data?.error);
            } else if (res.data?.error !== undefined) {
              error(res.data?.error);
              if (res.data?.error === "Invalid token!") {
                dispatch(actionLogout());
              }
            } else {
              success(res?.data?.message);
            }
          })
          .catch((err) => {
            error(err?.error?.data?.error);
          });
      } else if (isAuth && profile?.lgbt_status === 0) {
        noPermissionAlert();
      } else {
        waringMessage("Job Bookmark");
      }
    },
    [addBookmark, isAuth, profile, dispatch]
  );

  const handleApply = useCallback(
    (id) => {
      if (isAuth && profile?.lgbt_status === 1) {
        applyJob(id)
          .then((res) => {
            if (res?.error?.data?.error !== undefined) {
              error(res?.error?.data?.error);
            } else if (res.data?.error !== undefined) {
              error(res.data?.error);
              if (res.data?.error === "Invalid token!") {
                dispatch(actionLogout());
              }
            } else {
              success(res?.data?.message);
            }
          })
          .catch((err) => {
            error(err?.error?.data?.error);
          });
      } else if (
        isAuth &&
        (profile?.lgbt_status === 0 || profile?.lgbt_status === 4)
      ) {
        noPermissionAlert();
      } else {
        waringMessage("Apply Job");
      }
    },
    [applyJob, isAuth, profile, dispatch]
  );

  const handleSetJobNature = useCallback(() => {
    let jN = [];
    if (props?.item?.full_time === "Yes") jN.push("Full-Time");
    if (props?.item?.part_time === "Yes") jN.push("Part-Time");
    if (props?.item?.wfh === "Yes") jN.push("Work From Home");
    if (props?.item?.intership === "Yes") jN.push("Internship");

    setJobNature(jN);
  }, [setJobNature, props?.item]);

  useEffect(() => {
    handleSetJobNature();
  }, [handleSetJobNature]);

  return (
    <div className="single-post d-flex flex-row">
      <div className="thumb pr-30" style={{ width: "150px" }}>
        {profile_image ? (
          <img
            //className="img-fluid"
            src={path + encodeURI(profile_image)}
            alt={job_title ?? "NA"}
            width={120}
          />
        ) : (
          <img
            //className="img-fluid"
            src={path + "hiring.jpeg"}
            alt={job_title ?? "NA"}
            width={120}
          />
        )}
        {/* <img
          src={require("../../Assets/img/comapny-logos/acuity.jpg")}
          width={120}
          alt=""
        /> */}
      </div>
      <div className="details flex-grow">
        <div className="title d-flex flex-row justify-content-between">
          <div className="titles">
            <Link to={`/job-detail/${id}`}>
              <h4>{job_title ?? "Search Engine Optimaization Executive"}</h4>
            </Link>
            <h6>{company_name ? company_name : "NA"}</h6>
          </div>
          <ul className="btns pull-right">
            <li
              className={`mr-1 mb-1 ${
                profile?.lgbt_status === 3 ? "disabled" : ""
              }`}
              onClick={() =>
                profile?.lgbt_status === 3 ? () => {} : handleBookmark(id)
              }
            >
              <Link to="#" className="signin">
                <span className="lnr lnr-heart" />
              </Link>
            </li>
            <li
              className={`${profile?.lgbt_status === 3 ? "disabled" : ""}`}
              onClick={() =>
                profile?.lgbt_status === 3 ? () => {} : handleApply(id)
              }
            >
              <Link to="#" className="">
                Apply
              </Link>
            </li>
          </ul>
        </div>
        <h5>Job Nature: {jobNature.join(", ")}</h5>
        <p className="address">
          <span className="lnr lnr-map" /> {locations}
        </p>
      </div>
    </div>
  );
}
